import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Footer.css";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";

const Footer = () => {
  // Managing the States
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });
  //Displaying  the notification box
  const [notificationType, setNotificationType] = useState("");
  const [displayNotification, setDisplayNotification] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  //destructuring the form data
  const { name, email, message } = formData;

  // setting the useRef
  const form = useRef();
  // console.log(formData.user_name);

  const sendEmail = (e) => {
    e.preventDefault();
    if (
      formData.user_name.trim().length !== 0 &&
      formData.user_email.trim().length !== 0 &&
      formData.message.trim().length !== 0
    ) {
      setLoading(true);

      emailjs
        .sendForm(
          "service_zrpk32v",
          "template_3hl9ehf",
          form.current,
          "ebvnampphJ_9LidHv"
        )
        .then(
          (result) => {
            // Setting the isFormSubmitte
            setLoading(false);
            // setIsFormSubmitted(true);
            // console.log(result.text);

            // Setting the formData to empty after submission
            // setFormData;
            setFormData({
              name: "",
              email: "",
              message: "",
            });

            // Displaying the success Message
            setNotificationType("success");
            setDisplayNotification(true);
            setDisplayMessage("Message Sent Successfully!!!");

            setTimeout(() => {
              setDisplayNotification(false);
            }, 5000);
          },
          (error) => {
            console.log(error.text);
          }
        );
    } else {
      // Displaying the success Message
      setNotificationType("error");
      setDisplayNotification(true);
      setDisplayMessage("Please Fill In All The Details In The Form");

      setTimeout(() => {
        setDisplayNotification(false);
      }, 5000);
    }
    // if(
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = () => {
  //   setLoading(true);
  //   // setLoading(false);
  // };
  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:dejanrobi90@gmail.com" className="p-text">
            dejtechbiz@gmail.com
          </a>
        </div>

        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel: +254746584526" className="p-text">
            tel: +254746584526
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <form className="submit_form" ref={form} onSubmit={sendEmail}>
          <div className="app__footer-form app__flex">
            {displayNotification && (
              <div
                className={`app__flex notification-msg ${
                  notificationType === "error" ? "error-msg" : "success-msg"
                }`}
              >
                <p>{displayMessage}</p>
              </div>
            )}

            <div className="app__flex">
              <input
                type="text"
                className="p-text"
                placeholder="Your Name"
                name="user_name"
                value={name}
                onChange={handleChangeInput}
              />
            </div>
            <div className="app__flex">
              <input
                type="email"
                className="p-text"
                placeholder="Your Email"
                name="user_email"
                value={email}
                onChange={handleChangeInput}
              />
            </div>
            <div>
              <textarea
                className="p-text"
                placeholder="Your Message"
                value={message}
                name="message"
                onChange={handleChangeInput}
              />
            </div>
            <button type="submit" className="p-text" value="Submit">
              {loading ? "Sending............" : "Send Message"}
            </button>
          </div>
        </form>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
